export const hirePageTabs = [
  'overview',
  'contracts',
  'payments',
  'checklists',
  'classification',
  'approvals',
] as const

export type HirePageTab = (typeof hirePageTabs)[number]

export const isHirePageTab = (value: string): value is HirePageTab =>
  (hirePageTabs as readonly string[]).includes(value)
